import { LanguageType } from '../components/common/header/language-const';

export const ARTICLE_COMMENTS_SECTION_ID = 'article-comments';

export const mobileBreakpoint = 428;
export const vmobileBreakpoint = 600;
export const vTabletBreakpoint = 834;
export const tabletBreakpoint = 1280;
export const desktopBreakpoint = 1440;
export const largeDesktopBreakpoint = 1920;

export const LOCALES_CODES: Record<LanguageType, string> = {
  en: 'en-US',
  ko: 'ko-KO',
  ar: 'ar-AR',
  de: 'de-DE',
  fr: 'fr-FR',
  es: 'es-ES',
  nb: 'nb-NO',
  da: 'da-DK',
  sv: 'sv-SE',
  nl: 'nl-NL',
} as const;

export const DISABLED_BUILD_LOCALES: LanguageType[] = ['ko', 'ar'];

export const JETBASE_NAME = 'JetBase';
export const JETBASE_ADDRESS = '30 N Gould St Ste R Sheridan, WY 82801';

export const HOME_KEY = 'home';
export const BLOG_KEY = 'blog';

export const HOME_NS = 'home';
export const LABELS_NS = 'labels';
export const COMMON_NS = 'common';
export const BLOG_NS = 'blog';
export const CASE_NS = 'case';
export const INDUSTRY_NS = 'industry';
export const SERVICES_NS = 'service';
export const TECHNOLOGIES_NS = 'technology';
export const CAREERS_NS = 'career';
export const ABOUT_NS = 'about';
export const CONTACT_NS = 'contact';
export const PARTNERSHIP_NS = 'partnership';
export const FAQ_NS = 'faq';
export const PRIVACY_POLICY_NS = 'privacy-policy';
export const TERMS_AND_CONDITIONS_NS = 'terms-and-conditions';
export const REFUND_POLICY_NS = 'refund-policy';

export const MAX_FILE_SIZE = 5 * 1024 * 1024;

export const HTTP_STATUSES = {
  NO_CONTENT: 204,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
};

export const RATING_ORGANIZATION_VALUE = 4.9;
export const RATING_ORGANIZATION_COUNT = 32;

export const emailValidationRegEx =
  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

export const ONE_MIN_IN_MILISEC = 60000;

export const ENGLISH_LANGUAGE = 'en';

// Own hosts: production, its www alias and staging. Absolute links to them are
// internal, so CMS content pointing at them is rewritten to a root-relative path
// (otherwise a link authored on production sends staging visitors to production).
export const SITE_HOSTS = ['jetbase.io', 'www.jetbase.io', 'beta.jetbase.io'];

export type CountryPhoneCode = {
  country: string;
  code: string;
  isoCountryCode: string;
};
export const countryPhoneCodes: CountryPhoneCode[] = [
  {
    country: 'Afghanistan',
    code: '+93',
    isoCountryCode: 'af',
  },
  {
    country: 'Albania',
    code: '+355',
    isoCountryCode: 'al',
  },
  {
    country: 'Algeria',
    code: '+213',
    isoCountryCode: 'dz',
  },
  {
    country: 'Andorra',
    code: '+376',
    isoCountryCode: 'ad',
  },
  {
    country: 'Angola',
    code: '+244',
    isoCountryCode: 'ao',
  },
  {
    country: 'Antigua and Barbuda',
    code: '+1',
    isoCountryCode: 'ag',
  },
  {
    country: 'Argentina',
    code: '+54',
    isoCountryCode: 'ar',
  },
  {
    country: 'Armenia',
    code: '+374',
    isoCountryCode: 'am',
  },
  {
    country: 'Australia',
    code: '+61',
    isoCountryCode: 'au',
  },
  {
    country: 'Austria',
    code: '+43',
    isoCountryCode: 'at',
  },
  {
    country: 'Azerbaijan',
    code: '+994',
    isoCountryCode: 'az',
  },
  {
    country: 'Bahrain',
    code: '+973',
    isoCountryCode: 'bh',
  },
  {
    country: 'Bangladesh',
    code: '+880',
    isoCountryCode: 'bd',
  },
  {
    country: 'Belarus',
    code: '+375',
    isoCountryCode: 'by',
  },
  {
    country: 'Belgium',
    code: '+32',
    isoCountryCode: 'be',
  },
  {
    country: 'Belize',
    code: '+501',
    isoCountryCode: 'bz',
  },
  {
    country: 'Benin',
    code: '+229',
    isoCountryCode: 'bj',
  },
  {
    country: 'Bhutan',
    code: '+975',
    isoCountryCode: 'bt',
  },
  {
    country: 'Bolivia',
    code: '+591',
    isoCountryCode: 'bo',
  },
  {
    country: 'Bosnia and Herzegovina',
    code: '+387',
    isoCountryCode: 'ba',
  },
  {
    country: 'Botswana',
    code: '+267',
    isoCountryCode: 'bw',
  },
  {
    country: 'Brazil',
    code: '+55',
    isoCountryCode: 'br',
  },
  {
    country: 'Brunei',
    code: '+673',
    isoCountryCode: 'bn',
  },
  {
    country: 'Bulgaria',
    code: '+359',
    isoCountryCode: 'bg',
  },
  {
    country: 'Burkina Faso',
    code: '+226',
    isoCountryCode: 'bf',
  },
  {
    country: 'Burundi',
    code: '+257',
    isoCountryCode: 'bi',
  },
  {
    country: 'Cabo Verde',
    code: '+238',
    isoCountryCode: 'cv',
  },
  {
    country: 'Cambodia',
    code: '+855',
    isoCountryCode: 'kh',
  },
  {
    country: 'Cameroon',
    code: '+237',
    isoCountryCode: 'cm',
  },
  {
    country: 'Canada',
    code: '+1',
    isoCountryCode: 'ca',
  },
  {
    country: 'Central African Republic',
    code: '+236',
    isoCountryCode: 'cf',
  },
  {
    country: 'Chad',
    code: '+235',
    isoCountryCode: 'td',
  },
  {
    country: 'Chile',
    code: '+56',
    isoCountryCode: 'cl',
  },
  {
    country: 'China',
    code: '+86',
    isoCountryCode: 'cn',
  },
  {
    country: 'Colombia',
    code: '+57',
    isoCountryCode: 'co',
  },
  {
    country: 'Comoros',
    code: '+269',
    isoCountryCode: 'km',
  },
  {
    country: 'Congo (Congo-Brazzaville)',
    code: '+242',
    isoCountryCode: 'cg',
  },
  {
    country: 'Costa Rica',
    code: '+506',
    isoCountryCode: 'cr',
  },
  {
    country: 'Croatia',
    code: '+385',
    isoCountryCode: 'hr',
  },
  {
    country: 'Cuba',
    code: '+53',
    isoCountryCode: 'cu',
  },
  {
    country: 'Cyprus',
    code: '+357',
    isoCountryCode: 'cy',
  },
  {
    country: 'Czechia (Czech Republic)',
    code: '+420',
    isoCountryCode: 'cz',
  },
  {
    country: 'Democratic Republic of the Congo (Congo-Kinshasa)',
    code: '+243',
    isoCountryCode: 'cd',
  },
  {
    country: 'Denmark',
    code: '+45',
    isoCountryCode: 'dk',
  },
  {
    country: 'Djibouti',
    code: '+253',
    isoCountryCode: 'dj',
  },
  {
    country: 'Dominica',
    code: '+1',
    isoCountryCode: 'dm',
  },
  {
    country: 'Dominican Republic',
    code: '+1',
    isoCountryCode: 'do',
  },
  {
    country: 'East Timor (Timor-Leste)',
    code: '+670',
    isoCountryCode: 'tl',
  },
  {
    country: 'Ecuador',
    code: '+593',
    isoCountryCode: 'ec',
  },
  {
    country: 'Egypt',
    code: '+20',
    isoCountryCode: 'eg',
  },
  {
    country: 'El Salvador',
    code: '+503',
    isoCountryCode: 'sv',
  },
  {
    country: 'Equatorial Guinea',
    code: '+240',
    isoCountryCode: 'gq',
  },
  {
    country: 'Eritrea',
    code: '+291',
    isoCountryCode: 'er',
  },
  {
    country: 'Estonia',
    code: '+372',
    isoCountryCode: 'ee',
  },
  {
    country: 'Eswatini (fmr. "Swaziland")',
    code: '+268',
    isoCountryCode: 'sz',
  },
  {
    country: 'Ethiopia',
    code: '+251',
    isoCountryCode: 'et',
  },
  {
    country: 'Fiji',
    code: '+679',
    isoCountryCode: 'fj',
  },
  {
    country: 'Finland',
    code: '+358',
    isoCountryCode: 'fi',
  },
  {
    country: 'France',
    code: '+33',
    isoCountryCode: 'fr',
  },
  {
    country: 'Gabon',
    code: '+241',
    isoCountryCode: 'ga',
  },
  {
    country: 'Gambia',
    code: '+220',
    isoCountryCode: 'gm',
  },
  {
    country: 'Georgia',
    code: '+995',
    isoCountryCode: 'ge',
  },
  {
    country: 'Germany',
    code: '+49',
    isoCountryCode: 'de',
  },
  {
    country: 'Ghana',
    code: '+233',
    isoCountryCode: 'gh',
  },
  {
    country: 'Greece',
    code: '+30',
    isoCountryCode: 'gr',
  },
  {
    country: 'Grenada',
    code: '+1',
    isoCountryCode: 'gd',
  },
  {
    country: 'Guatemala',
    code: '+502',
    isoCountryCode: 'gt',
  },
  {
    country: 'Guinea',
    code: '+224',
    isoCountryCode: 'gn',
  },
  {
    country: 'Guinea-Bissau',
    code: '+245',
    isoCountryCode: 'gw',
  },
  {
    country: 'Guyana',
    code: '+592',
    isoCountryCode: 'gy',
  },
  {
    country: 'Haiti',
    code: '+509',
    isoCountryCode: 'ht',
  },
  {
    country: 'Holy See',
    code: '+379',
    isoCountryCode: 'va',
  },
  {
    country: 'Honduras',
    code: '+504',
    isoCountryCode: 'hn',
  },
  {
    country: 'Hungary',
    code: '+36',
    isoCountryCode: 'hu',
  },
  {
    country: 'Iceland',
    code: '+354',
    isoCountryCode: 'is',
  },
  {
    country: 'India',
    code: '+91',
    isoCountryCode: 'in',
  },
  {
    country: 'Indonesia',
    code: '+62',
    isoCountryCode: 'id',
  },
  {
    country: 'Iran',
    code: '+98',
    isoCountryCode: 'ir',
  },
  {
    country: 'Iraq',
    code: '+964',
    isoCountryCode: 'iq',
  },
  {
    country: 'Ireland',
    code: '+353',
    isoCountryCode: 'ie',
  },
  {
    country: 'Israel',
    code: '+972',
    isoCountryCode: 'il',
  },
  {
    country: 'Italy',
    code: '+39',
    isoCountryCode: 'it',
  },
  {
    country: 'Ivory Coast',
    code: '+225',
    isoCountryCode: 'ci',
  },
  {
    country: 'Jamaica',
    code: '+1',
    isoCountryCode: 'jm',
  },
  {
    country: 'Japan',
    code: '+81',
    isoCountryCode: 'jp',
  },
  {
    country: 'Jordan',
    code: '+962',
    isoCountryCode: 'jo',
  },
  {
    country: 'Kazakhstan',
    code: '+7',
    isoCountryCode: 'kz',
  },
  {
    country: 'Kenya',
    code: '+254',
    isoCountryCode: 'ke',
  },
  {
    country: 'Kiribati',
    code: '+686',
    isoCountryCode: 'ki',
  },
  {
    country: 'Kosovo',
    code: '+383',
    isoCountryCode: 'xk',
  },
  {
    country: 'Kuwait',
    code: '+965',
    isoCountryCode: 'kw',
  },
  {
    country: 'Kyrgyzstan',
    code: '+996',
    isoCountryCode: 'kg',
  },
  {
    country: 'Laos',
    code: '+856',
    isoCountryCode: 'la',
  },
  {
    country: 'Latvia',
    code: '+371',
    isoCountryCode: 'lv',
  },
  {
    country: 'Lebanon',
    code: '+961',
    isoCountryCode: 'lb',
  },
  {
    country: 'Lesotho',
    code: '+266',
    isoCountryCode: 'ls',
  },
  {
    country: 'Liberia',
    code: '+231',
    isoCountryCode: 'lr',
  },
  {
    country: 'Libya',
    code: '+218',
    isoCountryCode: 'ly',
  },
  {
    country: 'Liechtenstein',
    code: '+423',
    isoCountryCode: 'li',
  },
  {
    country: 'Lithuania',
    code: '+370',
    isoCountryCode: 'lt',
  },
  {
    country: 'Luxembourg',
    code: '+352',
    isoCountryCode: 'lu',
  },
  {
    country: 'Madagascar',
    code: '+261',
    isoCountryCode: 'mg',
  },
  {
    country: 'Malawi',
    code: '+265',
    isoCountryCode: 'mw',
  },
  {
    country: 'Malaysia',
    code: '+60',
    isoCountryCode: 'my',
  },
  {
    country: 'Maldives',
    code: '+960',
    isoCountryCode: 'mv',
  },
  {
    country: 'Mali',
    code: '+223',
    isoCountryCode: 'ml',
  },
  {
    country: 'Malta',
    code: '+356',
    isoCountryCode: 'mt',
  },
  {
    country: 'Marshall Islands',
    code: '+692',
    isoCountryCode: 'mh',
  },
  {
    country: 'Mauritania',
    code: '+222',
    isoCountryCode: 'mr',
  },
  {
    country: 'Mauritius',
    code: '+230',
    isoCountryCode: 'mu',
  },
  {
    country: 'Mexico',
    code: '+52',
    isoCountryCode: 'mx',
  },
  {
    country: 'Micronesia',
    code: '+691',
    isoCountryCode: 'fm',
  },
  {
    country: 'Moldova',
    code: '+373',
    isoCountryCode: 'md',
  },
  {
    country: 'Monaco',
    code: '+377',
    isoCountryCode: 'mc',
  },
  {
    country: 'Mongolia',
    code: '+976',
    isoCountryCode: 'mn',
  },
  {
    country: 'Montenegro',
    code: '+382',
    isoCountryCode: 'me',
  },
  {
    country: 'Morocco',
    code: '+212',
    isoCountryCode: 'ma',
  },
  {
    country: 'Mozambique',
    code: '+258',
    isoCountryCode: 'mz',
  },
  {
    country: 'Myanmar (formerly Burma)',
    code: '+95',
    isoCountryCode: 'mm',
  },
  {
    country: 'Namibia',
    code: '+264',
    isoCountryCode: 'na',
  },
  {
    country: 'Nauru',
    code: '+674',
    isoCountryCode: 'nr',
  },
  {
    country: 'Nepal',
    code: '+977',
    isoCountryCode: 'np',
  },
  {
    country: 'Netherlands',
    code: '+31',
    isoCountryCode: 'nl',
  },
  {
    country: 'New Zealand',
    code: '+64',
    isoCountryCode: 'nz',
  },
  {
    country: 'Nicaragua',
    code: '+505',
    isoCountryCode: 'ni',
  },
  {
    country: 'Niger',
    code: '+227',
    isoCountryCode: 'ne',
  },
  {
    country: 'Nigeria',
    code: '+234',
    isoCountryCode: 'ng',
  },
  {
    country: 'North Korea',
    code: '+850',
    isoCountryCode: 'kp',
  },
  {
    country: 'North Macedonia (formerly Macedonia)',
    code: '+389',
    isoCountryCode: 'mk',
  },
  {
    country: 'Norway',
    code: '+47',
    isoCountryCode: 'no',
  },
  {
    country: 'Oman',
    code: '+968',
    isoCountryCode: 'om',
  },
  {
    country: 'Pakistan',
    code: '+92',
    isoCountryCode: 'pk',
  },
  {
    country: 'Palau',
    code: '+680',
    isoCountryCode: 'pw',
  },
  {
    country: 'Palestine State',
    code: '+970',
    isoCountryCode: 'ps',
  },
  {
    country: 'Panama',
    code: '+507',
    isoCountryCode: 'pa',
  },
  {
    country: 'Papua New Guinea',
    code: '+675',
    isoCountryCode: 'pg',
  },
  {
    country: 'Paraguay',
    code: '+595',
    isoCountryCode: 'py',
  },
  {
    country: 'Peru',
    code: '+51',
    isoCountryCode: 'pe',
  },
  {
    country: 'Philippines',
    code: '+63',
    isoCountryCode: 'ph',
  },
  {
    country: 'Poland',
    code: '+48',
    isoCountryCode: 'pl',
  },
  {
    country: 'Portugal',
    code: '+351',
    isoCountryCode: 'pt',
  },
  {
    country: 'Qatar',
    code: '+974',
    isoCountryCode: 'qa',
  },
  {
    country: 'Romania',
    code: '+40',
    isoCountryCode: 'ro',
  },
  {
    country: 'Russia',
    code: '+7',
    isoCountryCode: 'ru',
  },
  {
    country: 'Rwanda',
    code: '+250',
    isoCountryCode: 'rw',
  },
  {
    country: 'Saint Kitts and Nevis',
    code: '+1',
    isoCountryCode: 'kn',
  },
  {
    country: 'Saint Lucia',
    code: '+1',
    isoCountryCode: 'lc',
  },
  {
    country: 'Saint Vincent and the Grenadines',
    code: '+1',
    isoCountryCode: 'vc',
  },
  {
    country: 'Samoa',
    code: '+685',
    isoCountryCode: 'ws',
  },
  {
    country: 'San Marino',
    code: '+378',
    isoCountryCode: 'sm',
  },
  {
    country: 'Sao Tome and Principe',
    code: '+239',
    isoCountryCode: 'st',
  },
  {
    country: 'Saudi Arabia',
    code: '+966',
    isoCountryCode: 'sa',
  },
  {
    country: 'Senegal',
    code: '+221',
    isoCountryCode: 'sn',
  },
  {
    country: 'Serbia',
    code: '+381',
    isoCountryCode: 'rs',
  },
  {
    country: 'Seychelles',
    code: '+248',
    isoCountryCode: 'sc',
  },
  {
    country: 'Sierra Leone',
    code: '+232',
    isoCountryCode: 'sl',
  },
  {
    country: 'Singapore',
    code: '+65',
    isoCountryCode: 'sg',
  },
  {
    country: 'Slovakia',
    code: '+421',
    isoCountryCode: 'sk',
  },
  {
    country: 'Slovenia',
    code: '+386',
    isoCountryCode: 'si',
  },
  {
    country: 'Solomon Islands',
    code: '+677',
    isoCountryCode: 'sb',
  },
  {
    country: 'Somalia',
    code: '+252',
    isoCountryCode: 'so',
  },
  {
    country: 'South Africa',
    code: '+27',
    isoCountryCode: 'za',
  },
  {
    country: 'South Korea',
    code: '+82',
    isoCountryCode: 'kr',
  },
  {
    country: 'South Sudan',
    code: '+211',
    isoCountryCode: 'ss',
  },
  {
    country: 'Spain',
    code: '+34',
    isoCountryCode: 'es',
  },
  {
    country: 'Sri Lanka',
    code: '+94',
    isoCountryCode: 'lk',
  },
  {
    country: 'Sudan',
    code: '+249',
    isoCountryCode: 'sd',
  },
  {
    country: 'Suriname',
    code: '+597',
    isoCountryCode: 'sr',
  },
  {
    country: 'Sweden',
    code: '+46',
    isoCountryCode: 'se',
  },
  {
    country: 'Switzerland',
    code: '+41',
    isoCountryCode: 'ch',
  },
  {
    country: 'Syria',
    code: '+963',
    isoCountryCode: 'sy',
  },
  {
    country: 'Tajikistan',
    code: '+992',
    isoCountryCode: 'tj',
  },
  {
    country: 'Tanzania',
    code: '+255',
    isoCountryCode: 'tz',
  },
  {
    country: 'Thailand',
    code: '+66',
    isoCountryCode: 'th',
  },
  {
    country: 'Togo',
    code: '+228',
    isoCountryCode: 'tg',
  },
  {
    country: 'Tonga',
    code: '+676',
    isoCountryCode: 'to',
  },
  {
    country: 'Trinidad and Tobago',
    code: '+1',
    isoCountryCode: 'tt',
  },
  {
    country: 'Tunisia',
    code: '+216',
    isoCountryCode: 'tn',
  },
  {
    country: 'Turkey',
    code: '+90',
    isoCountryCode: 'tr',
  },
  {
    country: 'Turkmenistan',
    code: '+993',
    isoCountryCode: 'tm',
  },
  {
    country: 'Tuvalu',
    code: '+688',
    isoCountryCode: 'tv',
  },
  {
    country: 'Uganda',
    code: '+256',
    isoCountryCode: 'ug',
  },
  {
    country: 'Ukraine',
    code: '+380',
    isoCountryCode: 'ua',
  },
  {
    country: 'United Arab Emirates',
    code: '+971',
    isoCountryCode: 'ae',
  },
  {
    country: 'United Kingdom',
    code: '+44',
    isoCountryCode: 'gb',
  },
  {
    country: 'United States of America',
    code: '+1',
    isoCountryCode: 'us',
  },
  {
    country: 'Uruguay',
    code: '+598',
    isoCountryCode: 'uy',
  },
  {
    country: 'Uzbekistan',
    code: '+998',
    isoCountryCode: 'uz',
  },
  {
    country: 'Vanuatu',
    code: '+678',
    isoCountryCode: 'vu',
  },
  {
    country: 'Venezuela',
    code: '+58',
    isoCountryCode: 've',
  },
  {
    country: 'Vietnam',
    code: '+84',
    isoCountryCode: 'vn',
  },
  {
    country: 'Yemen',
    code: '+967',
    isoCountryCode: 'ye',
  },
  {
    country: 'Zambia',
    code: '+260',
    isoCountryCode: 'zm',
  },
  {
    country: 'Zimbabwe',
    code: '+263',
    isoCountryCode: 'zw',
  },
];
